import React from "react";

const VyntezBuddyLogo = ({ compact = false }) => {
  return (
    <div className={compact ? "vb-logo vb-logo-compact" : "vb-logo"}>
      <span className="vb-logo-mark" aria-hidden="true">
        <span></span>
        <span></span>
      </span>
      <div className="vb-logo-copy">
        <h1>Vyntez Buddy</h1>
        {!compact && <p>Services at home</p>}
      </div>
    </div>
  );
};

export default VyntezBuddyLogo;
